import { QueryKey } from "@tanstack/react-query";

export const leadAsPublicQueryKeys = {
  all: () => ["leadAsPublic"] as QueryKey,
};
